export default "__VITE_ASSET__Dm6FRGMG__"